// extracted by mini-css-extract-plugin
export var filterIncDec = "_ft-0";
export var leftBorder = "_ft-1";
export var rightBorder = "_ft-2";
export var stringInput = "_ft-3";